import { Typography } from '@mui/material';

interface SummaryDateLineProps {
  text: string | React.ReactNode;
}

export const SummaryDateLine = ({ text }: SummaryDateLineProps) => {
  return (
    <Typography variant="bodyMedium" component="div">
      {text}
    </Typography>
  );
};
